<template>
  <div class="page">
    <div class="page__header">
      <div class="page__title">企业统计</div>
      <div class="page__headerRight">
        <el-input v-model="search.name" size="mini" clearable placeholder="企业名称" style="width: 240px; margin-right: 8px"
          @change="fetchInit" @clear="fetchInit"></el-input>
        <el-select v-model="search.platformName" size="mini" filterable clearable placeholder="场站"
          style="width: 240px; margin-right: 8px" @change="fetchInit">
          <el-option v-for="item in platformList" :key="item.id" :label="item.name" :value="item.name" />
        </el-select>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="fetchInit">查询</el-button>
        <el-button size="mini" icon="el-icon-refresh" style="margin-left: 8px" @click="init">刷新</el-button>
      </div>
    </div>
    <div class="page__body">
      <el-table :data="tenantRows" border size="mini" style="width: 100%" height="100%" v-loading="loading"
        @sort-change="handleSortChange">
        <template slot="empty">
          <el-empty></el-empty>
        </template>
        <el-table-column label="行号" type="index" width="60" align="center" />
        <el-table-column prop="tenantName" label="企业名称" min-width="220" show-overflow-tooltip align="center" sortable />
        <el-table-column label="电脑端访问次数" align="center">
          <template v-for="item in pcList">
            <el-table-column :prop="item.value" :label="item.label" width="80" show-overflow-tooltip align="center"
              sortable>
              <template v-slot="scope">
                <span class="pc-class">
                  {{ scope.row[item.value] > 0 ? scope.row[item.value] + ' 次' : '--' }}
                </span>
              </template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column label="小程序访问次数" align="center">
          <template v-for="item in miniProgramList">
            <el-table-column :prop="item.value" :label="item.label" width="80" show-overflow-tooltip align="center"
              sortable>
              <template v-slot="scope">
                <span class="mini-program-class">
                  {{ scope.row[item.value] > 0 ? scope.row[item.value] + ' 次' : '--' }}
                </span>
              </template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column prop="userCount" label="用户" width="80" align="center" sortable>
          <template v-slot="scope">
            <span class="user-class">
              {{ scope.row.userCount > 0 ? scope.row.userCount + ' 人' : '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="relPlatformCount" label="关联场站" width="100" align="center" sortable>
          <template v-slot="scope">
            <span class="platform-class">
              {{ scope.row.relPlatformCount > 0 ? scope.row.relPlatformCount + ' 个' : '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="200" label="操作" align="center">
          <template v-slot="scope">
            <el-button size="mini" type="primary" @click="openUsers(scope.row)" v-if="scope.row.userCount > 0">
              查看用户
            </el-button>
            <el-button size="mini" type="success" @click="openPlatforms(scope.row)"
              v-if="scope.row.relPlatformList.length > 0">
              查看场站
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page__footer">
      <el-pagination @size-change="handleTenantSizeChange" @current-change="handleTenantCurrentChange"
        :current-page="tenantPage.current" :page-sizes="[20, 50, 80, 100, 200]" :page-size="tenantPage.size"
        layout="total, sizes, prev, pager, next, jumper" :total="tenantPage.total" background>
      </el-pagination>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" fullscreen :close-on-click-modal="false"
      custom-class="tenant-user-dialog">
      <div class="dialog__header">
        <div class="dialog__headerLeft">共 {{ userPage.total }} 人</div>
        <div class="dialog__headerRight">
          <el-input v-model="userSearch.name" size="mini" clearable placeholder="姓名/名称"
            style="width: 220px; margin-right: 8px" @change="fetchUserList" @clear="fetchUserList"></el-input>
          <el-input v-model="userSearch.phone" size="mini" clearable placeholder="手机号"
            style="width: 180px; margin-right: 8px" @change="fetchUserList" @clear="fetchUserList"></el-input>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="fetchUserList">查询</el-button>
          <el-button size="mini" icon="el-icon-refresh" style="margin-left: 8px" @click="resetUserSearch">重置</el-button>
        </div>
      </div>
      <div v-loading="detailLoading" element-loading-text="加载用户列表中..."
        style="height: calc(100% - 50px); overflow: hidden;">
        <div style="height: calc(100% - 54px);">
          <el-table :data="userRows" border size="mini" height="100%" @sort-change="handleUserSortChange">
            <template slot="empty">
              <el-empty></el-empty>
            </template>
            <el-table-column label="行号" type="index" width="60" align="center" />
            <el-table-column prop="userName" label="姓名" width="100" align="center" show-overflow-tooltip sortable />
            <el-table-column prop="userPhone" label="手机号" width="120" align="center" show-overflow-tooltip sortable />
            <el-table-column label="电脑端访问次数" align="center">
              <template v-for="item in pcList">
                <el-table-column :prop="item.value" :label="item.label" width="80" show-overflow-tooltip align="center"
                  sortable>
                  <template v-slot="scope">
                    <span class="pc-class">
                      {{ scope.row[item.value] > 0 ? scope.row[item.value] + ' 次' : '--' }}
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
            <el-table-column label="小程序访问次数" align="center">
              <template v-for="item in miniProgramList">
                <el-table-column :prop="item.value" :label="item.label" width="80" show-overflow-tooltip align="center"
                  sortable>
                  <template v-slot="scope">
                    <span class="mini-program-class">
                      {{ scope.row[item.value] > 0 ? scope.row[item.value] + ' 次' : '--' }}
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
            <el-table-column prop="lastTime" label="最近登录时间" width="140" align="center" show-overflow-tooltip sortable />
            <el-table-column prop="roleList" label="权限" min-width="120" align="center" show-overflow-tooltip>
              <template v-slot="scope">
                <span v-if="scope.row.roleList && scope.row.roleList.length > 0">
                  {{scope.row.roleList.map(item => item.roleName).join('、')}}
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page__footer">
          <el-pagination @size-change="handleUserSizeChange" @current-change="handleUserCurrentChange"
            :current-page="userPage.current" :page-sizes="[20, 50, 80, 100, 200]" :page-size="userPage.size"
            layout="total, sizes, prev, pager, next, jumper" :total="userPage.total" background>
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="platformDialogTitle" :visible.sync="platformDialogVisible" width="70%"
      :close-on-click-modal="false">
      <div class="dialog__header">
        <div class="dialog__headerLeft">共 {{ platformTotal }} 个场站</div>
        <div class="dialog__headerRight">
          <el-input v-model="platformSearch.platformName" size="mini" clearable placeholder="场站名称"
            style="width: 240px; margin-right: 8px" @change="applyPlatformFilter"
            @clear="applyPlatformFilter"></el-input>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="applyPlatformFilter">查询</el-button>
          <el-button size="mini" icon="el-icon-refresh" style="margin-left: 8px"
            @click="resetPlatformSearch">重置</el-button>
        </div>
      </div>
      <div v-loading="platformLoading" element-loading-text="加载场站中..." style="min-height: 240px;">
        <el-table :data="platformRows" border size="mini" style="width: 100%" height="420">
          <template slot="empty">
            <el-empty></el-empty>
          </template>
          <el-table-column label="行号" type="index" width="60" align="center" />
          <el-table-column prop="platformName" label="场站名称" min-width="200" show-overflow-tooltip align="center" />
          <el-table-column prop="isAdmin" label="是否管理" width="120" align="center">
            <template v-slot="scope">
              <el-tag :type="scope.row.isAdmin ? 'success' : 'danger'" size="mini">
                {{ scope.row.isAdmin ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="platformDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'TenantUser',
  data() {
    return {
      search: {
        name: '',
        platformName: ''
      },
      loading: false,
      tenantRows: [],
      dialogVisible: false,
      dialogTitle: '用户列表',
      detailLoading: false,
      platformDialogVisible: false,
      platformDialogTitle: '关联场站',
      platformLoading: false,
      platformAllRows: [],
      platformRows: [],
      platformSearch: {
        platformName: ''
      },
      orderBy: 'pcYesterdayPv',
      orderDirection: 'desc',
      userOrderBy: 'pcYesterdayPv',
      userOrderDirection: 'desc',
      currentTenant: null,
      platformList: [],
      userRows: [],
      userSearch: {
        name: '',
        phone: '',
      },
      pcList: [
        { value: 'pcYesterdayPv', label: '昨日' },
        { value: 'pcThisWeekPv', label: '本周' },
        { value: 'pcLastWeekPv', label: '上周' },
        { value: 'pcThisMonthPv', label: '本月' },
        { value: 'pcLastMonthPv', label: '上月' }
      ],
      miniProgramList: [
        { value: 'miniProgramYesterdayPv', label: '昨日' },
        { value: 'miniProgramThisWeekPv', label: '本周' },
        { value: 'miniProgramLastWeekPv', label: '上周' },
        { value: 'miniProgramThisMonthPv', label: '本月' },
        { value: 'miniProgramLastMonthPv', label: '上月' }
      ],
      tenantPage: {
        total: 0,
        size: 20,
        current: 1
      },
      userPage: {
        total: 0,
        size: 20,
        current: 1
      }
    }
  },
  mounted() {
    this.init()
    this.fetchAllPlatformList()
    this.$validate.ToDocumentTitle()
  },
  computed: {
    userTotal() {
      return Array.isArray(this.userRows) ? this.userRows.length : 0
    },
    platformTotal() {
      return Array.isArray(this.platformRows) ? this.platformRows.length : 0
    }
  },
  methods: {
    async init() {
      await this.fetchInit()
    },
    async fetchInit() {
      this.$set(this.tenantPage, 'current', 1)
      await this.fetchTenantList()
    },
    async fetchAllPlatformList() {
      const res = await this.$axios.get('/account/platform/all')
      this.platformList = res.data.data
    },
    async fetchTenantList() {
      this.loading = true
      try {
        const config = {
          pageNum: this.tenantPage.current,
          pageSize: this.tenantPage.size,
          tenantName: this.search.name || undefined,
          platformName: this.search.platformName || undefined,
          orderBy: this.orderBy,
          orderDirection: this.orderDirection
        }
        const res = await this.$axios.post('/account/tenant/pageTenantAndPlatform', config)
        this.tenantRows = res.data.data.list
        this.tenantRows.forEach(item => {
          if (item.relPlatformList.length > 0 && item.platformList.length > 0) {
            const itemIdList = item.platformList.map(item => item.platformId)
            item.relPlatformList.forEach(platform => {
              if (itemIdList.includes(platform.platformId)) {
                platform.isAdmin = true
              }
            })
          }
        })
        this.$set(this.tenantPage, 'total', res.data.data.total)
      } catch (e) {
        this.tenantRows = []
        this.$set(this.tenantPage, 'total', 0)
      } finally {
        this.loading = false
      }
    },
    handleTenantSizeChange(val) {
      this.$set(this.tenantPage, 'size', val)
      this.$set(this.tenantPage, 'current', 1)
      this.fetchTenantList()
    },
    handleTenantCurrentChange(val) {
      this.$set(this.tenantPage, 'current', val)
      this.fetchTenantList()
    },
    handleUserSizeChange(val) {
      this.$set(this.userPage, 'size', val)
      this.$set(this.userPage, 'current', 1)
      this.fetchUserList()
    },
    handleUserCurrentChange(val) {
      this.$set(this.userPage, 'current', val)
      this.fetchUserList()
    },
    async openUsers(row) {
      this.currentTenant = row
      this.dialogTitle = `${row.tenantName} - 用户列表`
      this.dialogVisible = true
      this.userRows = []
      this.userSearch = { name: '', phone: '' }
      this.userOrderBy = 'pcYesterdayPv'
      this.userOrderDirection = 'desc'
      this.$set(this.userPage, 'current', 1)
      await this.fetchUserList()
    },
    async openPlatforms(row) {
      this.currentTenant = row
      this.platformDialogTitle = `${row.tenantName} - 关联场站`
      this.platformDialogVisible = true
      this.platformAllRows = []
      this.platformRows = []
      this.platformSearch = { platformName: '' }
      await this.fetchPlatformList(row)
      this.applyPlatformFilter()
    },
    async resetUserSearch() {
      this.userSearch = { name: '', phone: '' }
      await this.fetchUserList()
    },
    async fetchUserList() {
      this.userRows = []
      const config = {
        tenantId: this.currentTenant.tenantId,
        pageNum: this.userPage.current,
        pageSize: this.userPage.size,
        orderBy: this.userOrderBy,
        orderDirection: this.userOrderDirection,
        userName: this.userSearch.name || undefined,
        userPhone: this.userSearch.phone || undefined
      }
      this.detailLoading = true
      try {
        const res = await this.$axios.post('account/tenant/pageTenantUser', config)
        this.userRows = res.data.data.list || []
        this.$set(this.userPage, 'total', res.data.data.total)
      } finally {
        this.detailLoading = false
      }
    },
    resetPlatformSearch() {
      this.platformSearch = { platformName: '' }
      this.applyPlatformFilter()
    },
    applyPlatformFilter() {
      const platformName = (this.platformSearch.platformName || '').trim().toLowerCase()
      const source = Array.isArray(this.platformAllRows) ? this.platformAllRows : []
      this.platformRows = source.filter(row => {
        const rowName = String(row && (row.platformName || row.name) || '').toLowerCase()
        return !platformName || rowName.indexOf(platformName) !== -1
      })
    },
    handleSortChange(val) {
      this.sorts = val.order ? [{ field: val.prop, desc: 'descending' === val.order }] : [{ field: 'update_time', desc: true }]
      this.orderBy = val.order ? val.prop : 'pcYesterdayPv'
      this.orderDirection = !val.order ? 'desc' : val.order === 'descending' ? 'desc' : 'asc'
      this.fetchTenantList()
    },
    handleUserSortChange(val) {
      this.sorts = val.order ? [{ field: val.prop, desc: 'descending' === val.order }] : [{ field: 'update_time', desc: true }]
      this.userOrderBy = val.order ? val.prop : 'pcYesterdayPv'
      this.userOrderDirection = !val.order ? 'desc' : val.order === 'descending' ? 'desc' : 'asc'
      this.fetchUserList()
    },
    async fetchPlatformList(row) {
      this.platformAllRows = row.relPlatformList
      this.detailLoading = true
      this.detailLoading = false
    }
  }
}
</script>

<style scoped>
.page {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
}

.page__header {
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, #2f54eb, #4eb9b9);
  box-shadow: 0 6px 18px rgba(47, 84, 235, 0.18);
}

.page__title {
  font-size: 20px;
  font-weight: bold;
  background: linear-gradient(to right, #f3731d, #eeca66);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.page__headerRight {
  display: flex;
  align-items: center;
}

.page__headerRight :deep(.el-input__inner) {
  background: rgba(255, 255, 255, 0.92) !important;
}

.page__headerRight .el-button--default {
  border-color: rgba(255, 255, 255, 0.75) !important;
  background: rgba(255, 255, 255, 0.15) !important;
  color: #fff !important;
}

.page__headerRight .el-button--default:hover {
  background: rgba(255, 255, 255, 0.22) !important;
}

.page__body {
  width: 100%;
  height: calc(100% - 104px);
}

.page__footer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 52px;
}

.dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0 12px;
}

.dialog__headerLeft {
  font-size: 12px;
  color: #606266;
}

.dialog__headerRight {
  display: flex;
  align-items: center;
}

.pc-class {
  color: #f31313;
  font-weight: bold;
}

.mini-program-class {
  color: #1612df;
  font-weight: bold;
}

.user-class {
  color: #b67f2d;
  font-weight: bold;
}

.platform-class {
  color: #378149;
  font-weight: bold;
}
</style>

<style>
.tenant-user-dialog .el-dialog__body {
  height: calc(100% - 85px);
  padding: 10px 20px;
  overflow: hidden;
}
</style>